import React, { useState } from "react";
import logo from "../assets/logo.png";
import { CiUser } from "react-icons/ci";
import { HiMenu, HiX } from "react-icons/hi";
import product from "../assets/product1.png";
import product1 from "../assets/product2.png";
import product2 from "../assets/product3.png";
import product3 from "../assets/product4.png";
import product4 from "../assets/product5.png";
import product5 from "../assets/product6.png";
import product6 from "../assets/product7.png";
import product7 from "../assets/product8.png";
import sanitory from "../assets/sanitory.png";
import icon11 from "../assets/icon11.png";
import icon12 from "../assets/icon12.png";
import icon13 from "../assets/icon13.png";
import icon14 from "../assets/icon14.png";
import face from "../assets/face.png";
import twit from "../assets/video.png";
import insta from "../assets/insta.png";
import icon from "../assets/icon.png";
import icon1 from "../assets/icon1.png";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import { Link } from "react-router-dom";
import ProductInfo from "./ProductInfo";
import ProductImageGallery from "./ProductImageGallery";
import spbanner from "../assets/spbanner.png";
import flowerimg from "../assets/flowerimg.png";
import bdb from "../assets/bdb.jpeg";
import diaperFooterBanner from "../assets/diaperFooterBanner.jpeg";
import babypads from "../assets/babypads.png";
import gbwm from "../assets/bwm.png";
import bdicon1 from "../assets/bdicon1.png";
import bdicon2 from "../assets/bdicon2.png";
import bdicon3 from "../assets/bdt1.png";
import whale from "../assets/whale.png";
import bwt1 from "../assets/icons/Rashes.2.png";
import bdt2 from "../assets/icons/feathers.png";
import bdt3 from "../assets/icons/sleep.png";
import bdt4 from "../assets/icons/tested.png";
import returnIcon from "../assets/icons/arrow-right-left.svg";
import shippingIcon from "../assets/icons/la--shipping-fast.svg";

function Product1() {
    return (
        <>
            <Header />
            <Banner />
            <ProductDetail />
            <Siteicons />
            {/* <Imageround /> */}
            <ExtraSection />
            <ExtraSection1 />
            <ExtraSection2 />
            {/* <Diapericons /> */}
            <FAQSection />

            <FooterBanner />
            <Footer />
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative hidden">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser className="hidden" />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function Banner() {
    return (
        <div
            className=" lg:w-full  max-md:w-full md:w-full lg:h-screen max-md:h-screen md:h-[60vh] lg:bg-center lg:bg-no-repeat lg:bg-cover lg:object-fit-cover max-sm:w-full max-sm:h-[25vh]"
            style={{
                backgroundImage: `url(${bdb})`,
                backgroundSize: "cover", // Ensures the image covers the entire area
                backgroundPosition: "fit",
            }}
        >
            {/* Top Offer Bar */}
        </div>
    );
}

function ProductDetail() {
    return (
        <div className="mt-20 bg-white space-y-10 mx-auto text-justify px-4">
            <h2 className="text-4xl text-center font-bold">Product Features</h2>
            <h3 className="text-center text-xl font-[500] py-4">
                Bestie Baby Diapers: Where Comfort Meets Protection For Your
                Precious Little One
            </h3>
            <p className=" font-regular text-lg">
                Welcome to a world of unparalleled comfort and protection with
                Bestie Baby Diapers! Designed to wrap your little one in a{" "}
                <br />
                cocoon of care and comfort, these diapers are the ultimate
                choice for modern parents who demand the best for their baby.
            </p>
            <p className=" font-regular mt-5 text-lg">
                Indulge your baby in the softness of our diapers, crafted with a
                delicate touch that feels like a gentle hug against their skin,{" "}
                <br />
                beneath the surface lies cutting-edge technology that ensures
                maximum absorption and leakage protection, keeping your baby dry{" "}
                <br />
                and happy for longer.
            </p>
            <p className=" font-regular mt-5 text-lg">
                Say goodbye to worries about rashes and discomfort – our diapers
                are made from breathable materials that allow air to circulate{" "}
                <br />
                freely, promoting healthy skin and preventing irritation. Plus,
                our adorable designs add a touch of fun and style to your baby's{" "}
                <br />
                wardrobe, making diaper changes a delight rather than a chore.
            </p>
            <p className=" font-regular mt-5 text-lg">
                Experience the perfect blend of comfort and protection with
                Bestie Baby Diapers. Because when it comes to your little one,{" "}
                <br />
                only the best will do. Treat your baby to the care they deserve
                – shop Bestie Baby Diapers today!
            </p>
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                {/* <div className="flex items-center space-x-2 text-sm text-gray-500">
          <a href="/" className="font-sans text-lg font-medium hover:text-gray-700">Home</a>
          <span className="text-gray-400">›</span>
          <a href="/products" className="font-sans text-lg font-medium hover:text-black">Products</a>
          <span className="text-gray-400">›</span>
          <span className="font-sans text-lg font-medium hover:text-black">Bestie - Adult Diapers</span>
        </div> */}
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="w-full lg:w-1/2">
                        {/* <img
              src={product1}
              alt="Product Image"
               className="relative z-0 pl-10 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110"
            /> */}
                    </div>
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        {/* <h2 className="text-3xl font-bold">Bestie - Sanitory Pads</h2> */}
                        {/* <p className="mt-4 text-left text-gray-600">Welcome to a new era of personal hygiene with Bestie Sanitary Pads! 
Designed to offer unmatched comfort and protection, these pads are the ultimate choice for women who demand the best. Discover a world where your comfort and well-being are our top priorities.<br></br><br></br>
Indulge in the softness of our sanitary pads, featuring a super soft compressed random fibers surface that feels like a gentle caress against your skin. Beneath this luxurious surface lies advanced technology that ensures rapid absorption and superior leak protection, keeping you dry and comfortable all day long.<br></br><br></br>
Say goodbye to worries about leaks and discomfort. Our pads are equipped with a 3D leak guard that prevents side leakage, providing extra confidence and peace of mind. Plus, the anion strip with graphene neutralizes odors and offers antibacterial benefits, ensuring you feel fresh and clean.<br></br><br></br>
Experience enhanced hygiene with our air-laid sterilized paper, which creates a 360-degree sterile environment. Super absorbent polymers handle heavy flows with ease, reducing the need for frequent changes. The breathable, water-resistant bottom layer allows efficient air circulation, eliminating heat and moisture.<br></br><br></br>
Bestie sanitary pads also feature a high-level release mechanism for easy peel-and-stick convenience and are individually packed to ensure locked hygiene and cleanliness. Carry them in your bag or purse without worrying about contamination.<br></br><br></br>
Experience the perfect blend of comfort, protection, and hygiene with Bestie Sanitary Pads. Because when it comes to your health, only the best will do. Treat yourself to the care you deserve – shop Bestie Sanitary Pads today and feel the difference!<br></br><br></br>

</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
function Siteicons() {
    const fabiconsarray = [
        {
            id: 1,
            imageSrc: bwt1,
            imageAlt: "rashes icon",
            name: "Diapers absorb urine and poop, keeping the baby's skin dry and reducing the risk of rashes and infections.",
            href: "/icon11",
        },
        {
            id: 2,
            imageSrc: bdt2,
            imageAlt: "feature soft",
            name: "Diapers are designed to fit snugly and gently, allowing babies to move freely without discomfort. Their soft materials ensure a cozy feel for delicate skin.",
            href: "/icon12",
        },
        {
            id: 3,
            imageSrc: bdt3,
            imageAlt: "lock",
            name: "Diapers keep babies dry and comfy, helping them sleep peacefully through the night.",
            href: "/icon13",
        },
        {
            id: 4,
            imageSrc: bdt4,
            imageAlt: "chemical free",
            name: "Clinically tested and made 100% safe to skin and body",
            href: "/icon14",
        },
    ];
    return (
        <div className="mt-3 bg-white">
            <div className="px-4 py-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
                {/* <div className="flex items-center space-x-2 text-sm text-gray-500">
          <Link to="/" className="font-sans text-lg font-medium hover:text-gray-700">Home</Link>
          <span className="text-gray-400">›</span>
          <Link to="/products" className="font-sans text-lg font-medium hover:text-black">Products</Link>
        </div> */}

                <div className="px-10 py-10 mx-auto max-w-9xl sm:px-8 lg:px-8">
                    <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-4 lg:grid-cols-4 lg:gap-x-8 xl:gap-x-8">
                        {fabiconsarray.map((product) => (
                            <div
                                key={product.id}
                                className="relative 'overflow'-hidden bg-white border border-grey-200 shadow-lg group rounded-xl"
                            >
                                <div className="w-100 h-[60%] flex items-center justify-center px-2 py-2 bg-[#5BB1A2] aspect-w-1 aspect-h-1 rounded-t-xl lg:aspect-h-1">
                                    <img
                                        src={product.imageSrc}
                                        alt={product.name}
                                        className="w-[90%] h-[90%]  relative z-0 pt-0 pb-0 pl-0 pr-0 transition-all duration-300 rounded-lg lg:w-5/5 hover:scale-110 text-center"
                                    />
                                </div>
                                <div className="text-bold p-10 space-y-5  text-center text-black-500">
                                    <h3 className="text-bold text-black text-lg">
                                        {product.name}
                                    </h3>
                                    {/* <div className="flex items-center justify-between"> */}
                                    {/* <p className="text-lg font-bold text-black-900">{product.price}</p> */}
                                    {/* <Link to={product.href}>
                      <button className="py-1 px-4 bg-[#52B3A4] text-white text-sm rounded-md hover:bg-[#52B3A4]">
                        Shop Now
                      </button>
                    </Link> */}
                                    {/* </div> */}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

// function Imageround(){
//   return(
//     <div className="w-full lg:w-1/2">
//             <img
//               src={flowerimg}
//               alt="Product Image"
//                className="relative z-0 pl-100 transition-all duration-300 rounded-lg lg:w-10/10 hover:scale-110"
//             />
//           </div>
//   );
// }

function ExtraSection() {
    return (
        <div className="mt-1 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-6">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        <h2 className="text-2xl font-bold">
                            Bestie Baby Diapers:
                            <br />
                            Premium Comfort And Protection For Your Little One
                        </h2>
                        <p className="mt-4 text-left text-gray-600 text-lg">
                            <span className="font-semibold">
                                • Ultra-Thin Design:
                            </span>
                            Bestie Baby Diapers feature an ultra-thin design
                            that ensures a snug fit without compromising on
                            absorbency. This sleek design allows for ease of
                            movement, providing maximum comfort for your baby.
                            <br></br>
                            <br></br>•{" "}
                            <span className="font-semibold">
                                Superior Absorption:
                            </span>
                            The diapers incorporate advanced technology,
                            including specific pulp sheets and super absorbent
                            gel, ensuring superior absorption. This feature is
                            vital for keeping your baby dry and comfortable,
                            minimizing the need for frequent diaper changes.{" "}
                            <br></br>
                            <br></br>
                        </p>
                        {/* <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p> */}

                        {/* <a href="https://wa.me/message/WYDNZKOCNVM5A1">

            <button className="mt- px-10 py-4 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

          </a> */}
                    </div>
                    <div
                        className="w-full lg:w-1/3 md:ml-20"
                        style={{
                            backgroundImage: `url(${gbwm})`,
                            backgroundSize: "cover", // Ensures the image covers the entire area
                            backgroundPosition: "fit",
                        }}
                    >
                        <img
                            src={babypads}
                            alt="Product Image"
                            className="relative z-0 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110 pl-30"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function ExtraSection1() {
    return (
        <div className="mt-1 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500 "></div>
                <div className="flex flex-col-reverse mt-6 lg:flex-row">
                    <div
                        className="w-full lg:w-1/3 md:mr-20"
                        style={{
                            backgroundImage: `url(${gbwm})`,
                            backgroundSize: "cover", // Ensures the image covers the entire area
                            backgroundPosition: "fit",
                        }}
                    >
                        <img
                            src={bdicon1}
                            alt="Product Image"
                            className="relative z-0 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110 pl-30"
                        />
                    </div>

                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-30">
                        {/* <h2 className="text-3xl font-bold">About the Product - features</h2> */}

                        <p className="mt-4 text-left text-gray-600 text-lg">
                            •{" "}
                            <span className="font-semibold">
                                Soft Surfaces:
                            </span>
                            The top-notch soft surfaces of Bestie Baby Diapers
                            provide a gentle and comfortable touch against your
                            baby's delicate skin. This ensures that your little
                            one stays irritation-free and happy throughout the
                            day. <br></br>
                            <br></br>•{" "}
                            <span className="font-semibold">
                                Breathable Back Sheets:
                            </span>
                            The diapers are equipped with breathable back
                            sheets, promoting proper airflow and reducing
                            moisture buildup. This feature contributes to the
                            overall comfort of your baby and helps prevent skin
                            issues. <br></br>
                            <br></br>
                        </p>

                        {/* <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p> */}

                        {/* <a href="https://wa.me/message/WYDNZKOCNVM5A1">

            <button className="mt- px-10 py-4 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

          </a> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
function ExtraSection2() {
    return (
        <div className="mt-1 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        {/* <h2 className="text-3xl font-bold">About the Product - features</h2> */}
                        <p className="mt-4 text-left text-gray-600 text-lg">
                            •{" "}
                            <span className="font-semibold">
                                Standup Leg Cuffs:
                            </span>
                            The inclusion of standup leg cuffs not only ensures
                            a secure fit but also acts as a barrier to prevent
                            leaks. This feature keeps your baby dry and
                            comfortable, providing both security and peace of
                            mind for parents.
                            <br></br>
                            <br></br>
                        </p>
                        {/* <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p> */}
                    </div>
                    <div
                        className="w-full lg:w-1/3 md:ml-20"
                        style={{
                            backgroundImage: `url(${gbwm})`,
                            backgroundSize: "cover", // Ensures the image covers the entire area
                            backgroundPosition: "fit",
                        }}
                    >
                        <img
                            src={bdicon3}
                            alt="Product Image"
                            className="relative z-0 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110 pl-30"
                        />
                    </div>
                </div>
                <a
                    href="https://wa.me/message/WYDNZKOCNVM5A1"
                    className="ml-10"
                >
                    <button className="mt-10 px-5 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">
                        {" "}
                        Shop Now
                    </button>
                </a>
            </div>
        </div>
    );
}
function Diapericons() {
    return (
        <div className="w-1/2 lg:w-1/4 mr-20">
            <img
                src={whale}
                alt="Product Image"
                //  className="relative z-0 transition-all duration-300 rounded-lg lg:w-13/12 hover:scale-110 pr-30"
            />
        </div>
    );
}

// function ProductDetail1() {
//   return (
//     <div className="mt-10 bg-white">
//       <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
//         <div className="flex items-center space-x-2 text-sm text-gray-500">
//               </div>
//         <div className="flex flex-col mt-6 lg:flex-row">
//           <div className="w-full lg:w-1/2">

//             {/* <img
//               src={product2}
//               alt="Product Image"
//               className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
//             /> */}
//           </div>
//           <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
//             {/* <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
//             <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
//             <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>

//           <a href="https://wa.me/message/WYDNZKOCNVM5A1">

//             <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

//           </a> */}
//         </div>
//       </div>
//     </div>
//     </div >
//   );
// }

// function ProductDetail2() {
//   return (
//     <div className="mt-10 bg-white">
//       <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
//         <div className="flex items-center space-x-2 text-sm text-gray-500">

//         </div>
//         <div className="flex flex-col mt-6 lg:flex-row">

//           {/* <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
//             <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
//             <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
//             <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>

//           <a href="https://wa.me/message/WYDNZKOCNVM5A1">

//             <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

//           </a> */}
//         {/* </div> */}
//         <div className="w-full lg:w-1/2">

//         {/* <img
//               src={product2}
//               alt="Product Image"
//               className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
//             />      */}
//             </div>
//       </div>
//     </div>
//     </div >
//   );
// }

// function ProductDetail3() {
//   return (
//     <div className="mt-10 mb-10 bg-white">
//       <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
//         <div className="flex items-center space-x-2 text-sm text-gray-500">
//               </div>
//         <div className="flex flex-col mt-6 lg:flex-row">
//           <div className="w-full lg:w-1/2">

//           {/* <img
//               src={product4}
//               alt="Product Image"
//               className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
//             />  */}
//              </div>
//           <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
//             {/* <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
//             <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
//             <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>
//            */}

//           {/* <a href="https://wa.me/message/WYDNZKOCNVM5A1">

//             <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

//           </a> */}
//         </div>
//       </div>
//     </div>
//     </div >
//   );
// }

// // function RecommendedProducts() {
// //   const recommendedProducts = [
// //     {
// //       id: 1,
// //       name: "Bestie - Product 1",
// //       price: "₹550.00",
// //       imageSrc: product,
// //       href: "/product1",
// //     },
// //     {
// //       id: 2,
// //       name: "Product 2 Microfabric Fabric",
// //       price: "₹799.00",
// //       imageSrc: product1,
// //       href: "/product2",
// //     },
// //     {
// //       id: 3,
// //       name: "Microfabric Fabric T-Shirt",
// //       price: "₹799.00",
// //       imageSrc: product2,
// //       href: "/product3",
// //     },
// //     {
// //       id: 4,
// //       name: "Round Neck Full Sleeve T-Shirt",
// //       price: "₹599.00",
// //       imageSrc: product3,
// //       href: "/product4",
// //     },
// //   ];

// //   return (
// //     <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
// //       <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-6 xl:gap-x-8"></div>
// //       <h2 className="mb-10 font-sans text-2xl font-medium hover:text-black">Recommended Products</h2>

// //       <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
// //         {recommendedProducts.map((product) => (
// //           <div key={product.id} className="relative overflow-hidden bg-white border border-gray-200 shadow-lg group rounded-xl">
// //           <div className="w-full px-2 py-2 bg-white aspect-w-1 aspect-h-1 rounded-t-xl lg:aspect-none">
// //             <img
// //               src={product.imageSrc}
// //               alt={product.name}
// //               className="object-cover object-center w-full h-full lg:w-full lg:h-full"
// //             />
// //           </div>
// //           <div className="p-4 space-y-2">
// //             <h3 className="text-sm text-gray-700">
// //               {product.name}
// //             </h3>
// //             <div className="flex items-center justify-between">
// //               <p className="text-lg font-medium text-gray-900">{product.price}</p>
// //               <Link to={product.href}>
// //                 <button className="py-1 px-4 bg-[#52B3A4] text-white text-sm rounded-md hover:bg-[#52B3A4]">
// //                   Shop Now
// //                 </button>
// //               </Link>
// //             </div>
// //           </div>
// //         </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "My baby’s diaper sometimes leaks from the sides. What can I do? ",
            answer: "Leaks can happen due to an incorrect fit. Ensure that the diaper size matches your baby’s weight and that the leg cuffs are properly adjusted—tucking them outwards helps prevent leaks.",
        },
        {
            question: "How do I know when to transition my baby to the next diaper size? ",
            answer: "Signs that your baby needs a bigger diaper include frequent leaks, red marks around the waist or thighs, difficulty fastening the diaper securely, or your baby outgrowing the weight limit for their current size. Moving up a size ensures better comfort and leak protection.",
        },
        {
            question: " Do Bestie Baby Diapers contain any harmful chemicals?",
            answer: "No, Bestie Baby Diapers are free from harsh chemicals like chlorine, latex, and fragrances. They are designed to be safe for your baby’s delicate skin while providing top-tier absorbency and comfort.",
        },
        {
            question: " Can I use baby powder with Bestie Baby Diapers? ",
            answer: "While baby powder can help absorb excess moisture, many pediatricians recommend avoiding it as inhaling the fine particles may be harmful to infants. Instead, use a diaper cream or allow the skin to air dry before putting on a fresh diaper if incase baby skin is very sensitive.",
        },
        {
            question: "  Why does my baby’s diaper sometimes smell bad even when it’s not full? ",
            answer: "Strong odors can result from diet (certain foods can cause stronger urine smells), dehydration, or infrequent diaper changes. Make sure your baby is well-hydrated, and check that the diaper is absorbing properly ",
        },
        {
            question: " Is it okay to leave a slightly wet diaper on for longer or Can I reuse a diaper if my baby only peed a little?",
            answer: "It’s not recommended. Even with minimal wetness, bacteria can develop, leading to rashes and infections. The wetness indicator on Bestie Baby Diapers makes it easy to know when a change is needed, so always use a fresh diaper for hygiene and comfort.",
        },
    ];
    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="w-full py-16 bg-gray-50">
            {" "}
            {/* Full section wrapper with padding */}
            <div
                className="max-w-4xl 
      px-4 mx-auto sm:px-6 lg:px-8"
            >
                {" "}
                {/* Container for equal left-right space */}
                <h2 className="font-sans text-3xl font-semibold tracking-tight text-center text-gray-900">
                    Frequently Asked Questions
                </h2>
                <br></br>
                {/* FAQ List */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="pb-4 border-b-2 border-gray-200 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="font-sans text-lg font-semibold text-gray-700">
                                    {faq.question}
                                </h3>
                                <svg
                                    className={`w-6 h-6 transition-transform transform ${
                                        activeIndex === index
                                            ? "rotate-180"
                                            : ""
                                    }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                            {activeIndex === index && (
                                <p className="mt-2 text-gray-600">
                                    {faq.answer}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function FooterBanner() {
    return (
        <img
            src={diaperFooterBanner}
            alt="Banner"
            className="max-sm:object-contain max-sm:mx-0 max-sm:mb-0 object-fit lg:w-full lg:h-[90vh]"
        />
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-3">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={shippingIcon}
                        alt="Safe Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Shipping All Over India
                    </h3>
                </div>

                {/* Column 2 */}
                {/* <div className="flex flex-col items-center">
          <img src={icon1} alt="Secure Payment" className="w-12 h-12" />
          <br></br>
          <h3 className="font-sans font-bold">Secure Payment</h3>
          <p className="font-sans font-normal ">Guaranteed safe checkout</p>
        </div> */}

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Dedicated Customer Support
                    </h3>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={returnIcon}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Safe and quick delivery
                    </h3>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://www.facebook.com/bestie.care.hygiene/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.youtube.com/@BestieHygiene"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="youtube" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.instagram.com/bestie.hygienecare/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D# "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Bestie care. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default Product1;
